(function() {
'use strict';
const TR = angular.module('TR');

    ///NOTE: this is now deprecated, please use the validationMessage directive as that
    //is aligned with what we would like to do going forward with the look and feel and activation
    //or errors across the site.

TR.directive('validationErrors', function($rootScope, validationService, broker) {
    return {
        restrict: 'E',
        replace: true,
        priority: 1000,
        scope: {
            rootForm: '=',
            field: '=',
            label: '@',
            msgMap: '@',
            immediate: '@',
            stayActive: '@' // Error stays visible until another field is focused (i.e. whilst using calendar)
        },
        template: '<ul ng-class="{invalid:!field.$valid}" class="animate-fade flash-message error-message" ng-show="!field.$valid && showErrors()">' +
                   '    <li ng-show="val" ng-repeat="(name, val) in field.$error">' +
                   '        {{translate(name, val)}}' +
                   '    </li>' +
                   '</ul>',
        link(scope) {
            scope.showErrors = function() {
                const field = scope.field;
                if (field) {
                    const stayActive = (scope.stayActive === 'true' && field.lastFocused);

                    return (field.focused || stayActive || immediateTest()) &&
                            ($rootScope.submittedForm === scope.rootForm && !scope.rootForm.$valid || immediateTest());
                }
            };

            function immediateTest() {
                if (scope.immediate != null) {
                    if (scope.immediate === 'true') {
                        return true;
                    }
                    const immediate = scope.immediate.split('|');
                    for (const i in immediate) {
                        const doNow = immediate[i];
                        if (doNow && scope.field.$error[doNow]) {
                            return true;
                        }
                    }
                }
                return false;
            }

            const map = scope.msgMap == null ? {} : JSON.parse(scope.msgMap);

            const watcher = scope.$watch('field', function(val) {
                if (val) {
                    scope.field.label = scope.label;
                    watcher();
                }
            });

            scope.$watch(scope.showErrors, val => {
                if (val && scope.field.$invalid) {
                    const validationErrors = Object.keys(scope.field.$error)
                        .map(name => validationService.translateField(scope.field, name, map));
                    broker.publish('validationErrors', validationErrors);
                }
            });

            scope.translate = function(name, val) {
                if (!val) { return ''; }
                return validationService.translateField(scope.field, name, map);
            };
        }
    };
});
})();
